import { ManageCapacityPage } from "../../../web/pages/ManageCapacity";
import React, { useEffect, useState } from "react";
import {
  getManageCapacity,
  getManageCapacityLoaded,
  getManageCapacityTotalPages,
  getManageCapacityRemainingRecords,
  getManageSegmentSelected
} from "../../../selectors/Manage/selector";
import { CapacityModel } from "../../../models/manage/capacity.model";
import {
  removeManageCapacity,
  setSelectedCapacity,
  addManageCapacity,
  getCapacityListWithCount,
  setManageSegmentSelected
} from "../../../actions/manage/action";
import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from "../../../utils/injectReducer";
import reducer from "../../../reducers/manage/reducer";
import saga from "../../../saga/Manage/saga";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router";
import { compose } from "redux";
import {
  getNetworkStatus,
  getUserMasterData,
  getRefreshStatus,
  getLoading
} from "../../../selectors/selector";
import { showNetworkAlert, deleteDynamicLinkParams } from "../../../actions/App/action";

const key = "manage";

const ManageCapacityContainer = (props: any) => {
  const { isLoading, userDetails, getCapacityListAction } = props;
  const capacityModel = new CapacityModel();
  const pageSize: number = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const [isCapacityEnd, setCapacityEnd] = useState(false);
  const [selectedTab , setSelectedTab] = useState("ALL");
  const resetValues = () => {
    setCurrentPage(0);
    setCapacityEnd(false);
  };

  const getCapacityList = (
    page = 0,
    isRefresh: boolean = false,
    isPullToRefresh: boolean = false,
    selectedSegment: string = ""
  ) => {
    const query = capacityModel.getCarrierCapacityWithLoadCount(
      userDetails?.memberDetailsResponse?.member?.carrierId,
      page,
      pageSize,
      userDetails?.memberDetailsResponse?.member?.upn,
      userDetails?.memberDetailsResponse?.member?.upn,
      selectedSegment
    );
    if (isRefresh) {
      resetValues();
    }
    setCurrentPage(page);
    getCapacityListAction({
      query,
      isRefresh,
      isPullToRefresh,
    });
  };

  const onShowMoreHandler = async () => {

    if (!isCapacityEnd && !isLoading) {
      const page =  currentPage + 1;
      getCapacityList(page, false, false, selectedTab)    
    }
  };

  const location = useLocation();
  const history = useHistory();
  const locationState: any = location.state ?? {};
  const userPrincipalName: string =
    (userDetails?.memberDetailsResponse?.member?.upn) || "";

  useEffect(() => {
    if (
      userPrincipalName &&
      history.location.pathname == "/app/manage-capacity"
    ) {
        getCapacityList(0, true, false, "ALL");
    }
  }, [userPrincipalName, locationState.refreshKey]);

  const onTabChange = (selectedSegment:string) => {
    if (
      userPrincipalName &&
      history.location.pathname == "/app/manage-capacity" &&
      selectedTab !== selectedSegment
    ) {
      resetValues();
      getCapacityList(0, true, false, selectedSegment);
      setSelectedTab(selectedSegment);
    }
  }
  return (
    <ManageCapacityPage
      module="manage"
      {...props}
      isCapacityEnd={currentPage === props.totalPages}
      onShowMore={onShowMoreHandler}
      onTabChange={onTabChange}
      remainingLoads={(props.remainingRecords < 10 ? props.remainingRecords : 10)}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  isLoading: getLoading(),
  isCapacityLoaded: getManageCapacityLoaded(),
  isNetWorkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  isPullToRefresh: getRefreshStatus(),
  capacityList: getManageCapacity(),
  totalPages : getManageCapacityTotalPages(),
  remainingRecords : getManageCapacityRemainingRecords(),
  ManageSegmentSelected: getManageSegmentSelected(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  getCapacityListAction: (payload: any) =>
    dispatch(getCapacityListWithCount(payload)),
  addCapacityItem: (payload: any) => dispatch(addManageCapacity(payload)),
  removeCapacityAction: (payload: any) =>
    dispatch(removeManageCapacity(payload)),
  setSelectedCapacityAction: (payload: any) =>
    dispatch(setSelectedCapacity(payload)),
  clearDynamicLinkParams : ()=> dispatch(deleteDynamicLinkParams()),
  setManageSegmentSelected : (payload: any)=> dispatch(setManageSegmentSelected(payload)),
});

const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withSaga,
  withReducer,
  withConnect
)(withRouter(ManageCapacityContainer));
